import React from 'react';
import { Button, Box } from '@mui/material';
import MaterialPage from './MaterialPage';
import { useState } from 'react';
export default function MaterialPicker() {
    const [selected, setSelected] = useState([]);
    const params = new URLSearchParams(window.location.search);
    const nonce = params.get('nonce');

    const handleConfirm = () => {
        if(window.opener){
            window.opener.postMessage({
                type : 'MATERIALS_SELECTED',
                nonce,
                payload : selected,
            }, '*' /* 안전하면 정확한 ORIGINS 지정 */);
        }
        window.close();
    };

    return(
        <Box sx={{ p : 2}}>
            <MaterialPage
                enableCheckbox
                disablePagination={false}
                onSelectionChange={setSelected}
                initialSelection={[]}
                hideDeleteAction
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1 }}>
                <Button variant="outlined" onClick={() => window.close()}>취소</Button>
                <Button variant="contained" onClick={handleConfirm} disabled={selected.length === 0}>확인 ({selected.length}개 선택)</Button>
            </Box>
        </Box>
    );
}